var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 10C1.5 5.30558 5.30558 1.5 10 1.5C14.6944 1.5 18.5 5.30558 18.5 10C18.5 14.6944 14.6944 18.5 10 18.5C5.30558 18.5 1.5 14.6944 1.5 10ZM10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM5.08349 6.70767C4.67722 5.6882 5.68791 4.67747 6.7074 5.08372L10.7356 6.68888C11.9078 7.15602 12.8461 8.0704 13.3431 9.2303L15.1969 13.5557C15.6414 14.5929 14.5927 15.6415 13.5555 15.197L9.2301 13.3433C8.0703 12.8462 7.15587 11.908 6.68872 10.7358L5.08349 6.70767ZM6.69209 6.69233L8.0822 10.1805C8.4018 10.9825 9.0274 11.6245 9.821 11.9646L13.572 13.5721L11.9644 9.8212C11.6243 9.0276 10.9824 8.4019 10.1803 8.0823L6.69209 6.69233Z",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapping);
export default __webpack_public_path__ + "static/media/mapping.86cd78d5762b14019f69c93295e310a0.svg";
export { ForwardRef as ReactComponent };